export enum MUTATION_KEYS {
  CREATE_VIDEO = 'CREATE_VIDEO',
  DELETE_VIDEO = 'DELETE_VIDEO',
}

export default MUTATION_KEYS
